import { Trans } from '@lingui/react'

import { validator } from '@twistopayments/design-system/form'

export const MIN_PASSWORD_LENGTH = 8

export const defaultPasswordValidations = {
  lowerCase: (count: number) => (
    <Trans id="password.validation.lowerCase" values={{ count }} />
  ),
  upperCase: (count: number) => (
    <Trans id="password.validation.upperCase" values={{ count }} />
  ),
  specialChar: (count: number) => (
    <Trans id="password.validation.specialChar" values={{ count }} />
  ),
  minLength: (length?: number) => {
    const count = length ?? MIN_PASSWORD_LENGTH

    return <Trans id="password.validation.minLength" values={{ count }} />
  },
}

export const defaultPasswordRulesMap = {
  lowerCase: validator.isLowerCase,
  upperCase: validator.isUpperCase,
  specialChar: validator.isSpecialChar,
  minLength: validator.createMinLength(MIN_PASSWORD_LENGTH),
}
